
import { defineComponent } from 'vue'
import { PackageManager } from '~/types/types'
import { getPackageManagerName } from '~/utils/dependencies'

import CreateRepositoryTargetMutation from '~/apollo/mutations/dependency/createRepositoryTarget.gql'
import repoDetailMixin from '~/mixins/repoDetailMixin'

export default defineComponent({
  name: 'DependencyNewTargetModal',
  data() {
    return {
      selectedPackageManager: PackageManager.RequirementsTxt,
      manifestFilePath: '',
      lockfilePath: '',
      expandWhatIsTarget: false
    }
  },
  mixins: [repoDetailMixin],
  computed: {
    packageManagers() {
      return Object.values(PackageManager).map((manager) => ({
        id: manager,
        name: getPackageManagerName(manager)
      }))
    }
  },
  methods: {
    async addTarget() {
      if (!this.lockfilePath || !this.selectedPackageManager) {
        this.$toast.danger('Package Manager and Lock file path are required.')
        return
      }
      try {
        await this.$applyGraphqlMutation(CreateRepositoryTargetMutation, {
          input: {
            repositoryId: this.repository.id,
            packageManager: this.selectedPackageManager,
            manifestPath: this.manifestFilePath,
            lockfilePath: this.lockfilePath
          }
        })
        this.$emit('target-added')
        this.$toast.success('Target added successfully.')
        this.$emit('close')
      } catch (error) {
        const err = error as Error
        const message = (err?.message || '').replace(/^GraphQL error: /, '')
        const BILLING_ERROR_PHRASE = 'Cannot bill'
        const FILE_NOT_FOUND_PATTERN = /^(lockfile|manifest).+/i

        if (message.includes(BILLING_ERROR_PHRASE)) {
          this.$toast.show({
            type: 'danger',
            message:
              'You have exhausted your SCA target quota. Please purchase more targets or upgrade your plan.',
            timeout: 10
          })
        } else if (FILE_NOT_FOUND_PATTERN.test(message)) {
          this.$toast.show({ type: 'danger', message, timeout: 10 })
        } else {
          this.$logErrorAndToast(
            err,
            'Failed to add target. Please try again later or reach out to our support.'
          )
        }
      }
    }
  }
})
